import React from 'react';

export const ColorModeContext = React.createContext({
    toggleColorMode: () => {
        // This is intentional
    },
})